import React, { ReactNode } from 'react';
import { Modifier } from 'react-day-picker/types/Modifiers';
import { Control, RegisterOptions, useController } from 'react-hook-form';
import { FieldError } from 'react-hook-form/dist/types/errors';
import { startOfDay } from 'date-fns';
import { DATE_PLACEHOLDER } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { DatePickerInput } from 'src/components/DatePickerInput/DatePickerInput';

export interface DateInputProps {
  id: string;
  name: string;
  label: ReactNode;
  disabled?: boolean;
  control: Control;
  rules?: RegisterOptions;
  error?: FieldError;
  disabledDays?: Modifier | Modifier[];
  initialMonth?: Date;
  blockWidth?: boolean;
}

export const DATE_PICKER_DATE_FORMAT = 'eee MMM dd yyyy';

export const DateInput = ({
  id,
  name,
  label,
  disabled = false,
  control,
  rules = {},
  error,
  disabledDays,
  initialMonth,
  blockWidth = false,
}: DateInputProps): JSX.Element => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    rules,
    control,
    defaultValue: control.defaultValuesRef.current[name] ?? '',
  });

  return (
    <DatePickerInput
      disabled={disabled}
      forceMonthsToWrap
      initialDate={value}
      dayPickerProps={{
        ...(disabledDays && { disabledDays }),
        ...(initialMonth && { month: initialMonth }),
        numberOfMonths: 1,
      }}
      numberOfConsecutiveDays={1}
      useFullScreenOverlay
      placeholder={DATE_PLACEHOLDER}
      label={label as string}
      name={name}
      id={id}
      onDateChange={(value: Date): void => {
        onChange(startOfDay(value));
      }}
      error={error}
      blockWidth={blockWidth}
    />
  );
};
